export default "__VITE_ASSET__CewvbFvd__"